export const zh = {
    "en": "英文",
    "zh": "中文",
    "Language": "语言",
    "Text": "文本",
    "Required": "请输入{0}.",
    "Required1": "请输入{0}{1}.",
    "Minlength": "{0} 长度太短.",
    "Minlength1": "{0} {1} 长度太短.",
    "Minlength2": "{0}必须包含{1}个字符.",
    "Minlength3": "{0}{1}必须包含{2}个字符."
}